<template>
  <div v-if="isPorTrait" id="app">
    <router-view />
  </div>
  <div v-else class="porTrait-main-box">
    <div class="porTrait-item">
      <img />
      <span>为了更好的体验请将手机竖置</span>
    </div>
  </div>
</template>
<script>
import config from '../package.json'
export default {
  data() {
    return {
      isPorTrait: true,
      iosStyleSetted: false,
      bodyHeight:0,
      bodyWidth:0,
    };
  },
  created() {
    //this.checkVersion()
  },
  mounted() {
    const that = this;
    that.isPorTrait = window.orientation === 180 || window.orientation === 0
    this.reSetPageHeight(true,that.isPorTrait)
    //判断手机横竖屏状态：
    window.addEventListener(
      "onorientationchange" in window ? "orientationchange" : "resize",
      function() {
        that.isPorTrait = window.orientation === 180 || window.orientation === 0;
        if(!that.$btools.OS.isIOS()){
          that.bodyHeight =that.$storage.get('androidPageH')
          that.bodyWidth = that.$storage.get('androidPageW')
          if (that.isPorTrait) {
            document.body.style.height = that.bodyHeight + "px";
            //document.body.style.width = _bodyWidth + "px";
          } else {
            document.body.style.height = that.bodyWidth + "px";
            //document.body.style.width = _bodyHeight + "px";
          }
        }
      },
      false
    );
  },
  watch: {
    iosStyleSetted: {
      handler(v){
        if(!v){
          this.initIosFitStyle()
        }
      },
      immediate:true
    }
  },
  methods:{
    initIosFitStyle(){
      document.body.style.height= 'calc(96rpx+ constant(safe-area-inset-bottom));'//兼容 IOS<11.2

      document.body.style.height= 'calc(96rpx + env(safe-area-inset-bottom));'//兼容 IOS>11.2

      document.body.style.paddingBottom= 'constant(safe-area-inset-bottom);'//兼容 IOS<11.2

      document.body.style.paddingBottom= 'env(safe-area-inset-bottom);'//兼容 IOS>11.2
      this.iosStyleSetted = true
    },
    reSetPageHeight(init){
      this.bodyHeight = this.isPorTrait ? document.body.offsetHeight:document.body.offsetWidth;
      this.bodyWidth = this.isPorTrait ? document.body.offsetWidth:document.body.offsetHeight;
      if(init){
        this.$storage.set('androidPageH',this.bodyHeight)
        this.$storage.set('androidPageW',this.bodyWidth)
      }
      this.isPorTrait = window.orientation === 180 || window.orientation === 0;
      if(!this.$btools.OS.isIOS()){
        if (this.isPorTrait) {
          document.body.style.height = this.bodyHeight + "px";
          //document.body.style.width = _bodyWidth + "px";
        } else {
          document.body.style.height = this.bodyWidth + "px";
          //document.body.style.width = _bodyHeight + "px";
        }
      }
      this.$storage.set("isPorTrait", this.isPorTrait ? "T" : "F");
    },
    checkVersion(){
      const _verLocal = this.$storage.get('app-version')
      const _varConfig = config.version
      if(!_verLocal || this.compare(_verLocal,_varConfig)){
        localStorage.clear();
        if(!this.$btools.OS.isIOS()){
          window.ProxyStatus.clearCookieAndCache(1);// 清理 [Cookie]
          window.ProxyStatus.clearCookieAndCache(2);// 清理 [文件缓存] ★
          window.ProxyStatus.clearCookieAndCache(4);// 清理 [广告过滤缓存]
          window.ProxyStatus.clearCookieAndCache(8);// 清理 [DNS缓存]
        }
        this.$storage.set('app-version',config.version)
        this.$router.push("information");
      }
    },
    /*
      * 版本号比较方法
      * 传入两个字符串，当前版本号：curV；比较版本号：reqV
      * 调用方法举例：compare("1.1","1.2")，将返回false
    */
    compare(curV, reqV) {
      if (curV && reqV) {
        //将两个版本号拆成数字
        var arr1 = curV.split('.'), arr2 = reqV.split('.');
        var minLength = Math.min(arr1.length, arr2.length), position = 0, diff = 0;
        //依次比较版本号每一位大小，当对比得出结果后跳出循环（后文有简单介绍）
        while (position < minLength && ((diff = parseInt(arr1[position]) - parseInt(arr2[position])) == 0)) {
          position++;
        }
        diff = (diff != 0) ? diff : (arr1.length - arr2.length);
        //若curV大于reqV，则返回true
        return diff != 0;
      } else {
        //输入为空
        console.log("版本号不能为空");
        return false;
      }
    }
  }
};
</script>
<style lang="scss">
@import "~@/styles/index";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background-image: linear-gradient(108deg, #32383e, #1d1f23);
  height: 100%;
  width: 100%;
}
.porTrait-main-box {
  height: 100%;
  width: 100%;
  border: 0;
  background-image: linear-gradient(108deg, #32383e 0%, #1d1f23 100%);
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.06);
  .porTrait-item {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    width: auto;
    margin: auto;
    img {
      height: px2rem(50);
      width: px2rem(50);
      margin-bottom: px2rem(20);
      content: url("~@/assets/vertical-screen.png");
    }
    span {
      color: #fefefe;
      font-size: px2rem(16);
      margin-bottom: px2rem(50);
    }
  }
}
</style>
